import React from 'react';

//use it if you want to memoize a component that accepts generic type - D.Zghinnik 12.10.2023
export const typedMemo: <T>(c: T) => T = React.memo;

//use it if you want to wrap a component that accepts generic type to styled components  - D.Zghinnik 12.10.2023
// export const typedStyled: <T>(c: T) => T = styled;
